import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BalanceItem from './index';
import { setActiveAsset, setActiveTab } from '../../../../actions/staking-actions';
import { GAMER, GAMER_POLYGON, TOKEN_OPTIONS } from '../../../../constants/blockchain-constants';
import * as modalActions from '../../../../actions/modal-actions';
import { formatToken } from '../../../../helpers/token-helper';
import { ACCOUNT_MODAL } from '../../../../constants/modal-constants';
import { STAKE_TOKENS_PATH } from '../../../../constants/router-constants';

const GamerPolygon = () => {
  const dispatch = useDispatch();
  const { stakeBalance } = useSelector((state) => state.GAMERPOLYGONstake.stake);
  const { gamerPolygonBalance } = useSelector((state) => state.token);
  const usdPrice = useSelector((state) => state.basic.currency.USD[GAMER]);

  return (
    <BalanceItem
      token={GAMER}
      icon={TOKEN_OPTIONS[GAMER_POLYGON].icon}
      balance={gamerPolygonBalance}
      buttonText='Stake'
      formattedBalance={formatToken(gamerPolygonBalance)}
      usdPrice={usdPrice}
      formattedStakeBalance={formatToken(stakeBalance)}
      stakeBalance={stakeBalance}
      onClick={() => {
        dispatch(modalActions.hideModal(ACCOUNT_MODAL));
        dispatch(setActiveAsset(GAMER_POLYGON));
        dispatch(setActiveTab(STAKE_TOKENS_PATH));
      }}
    />
  );
};

export default GamerPolygon;
